export default __webpack_public_path__ + "static/cashflow_new_15-62d058d5e249890524ed680ffea9a8bf.jpg";